import { Box, Text, Button, Heading } from '@chakra-ui/react';
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link as RouteLink } from 'react-router-dom';
import { IRecordedInterviewEntry } from 'types';
import RecordedInterviewDescisionSegment from '../../../molecules/RecordedInterviewDescisionSegment';
import { useTranslation } from "react-i18next";

interface ActionButtonProps {
  isAssessed: boolean;
}
function ActionButton({ isAssessed }: ActionButtonProps) {
  const buttonText = isAssessed ? 'Edit' : 'Assess';
  const buttonColorScheme = isAssessed ? 'gray' : 'blue';
  const buttonTextColor = isAssessed ? 'blue' : undefined;
  return (
    <Button
      width="100%"
      size="lg"
      variant="solid"
      colorScheme={buttonColorScheme}
      color={buttonTextColor}
      as={RouteLink}
      to={'assess'}
    >
      {buttonText}
    </Button>
  );
}

interface AssessmentSectionProps {
  interview: IRecordedInterviewEntry;
  canEditScoresAndAssessment: boolean;
}

function AssessSection(props: AssessmentSectionProps) {
    const { t } = useTranslation('common');
  const { interview, canEditScoresAndAssessment } = props;
  const assessment = interview.userAssessment;

  const isAssessed = Boolean(assessment?.assessedAt);
  const isRevealedToUni = assessment?.revealAssessmentToUni ?? false;
  const notes = assessment?.assessmentNote ?? '';
  const descision = assessment?.assessmentDecision;
  const assessedBy = assessment?.assessedBy ?? '';

  const showNotes = (notes?.trim()?.length ?? 0) > 0;
  const isRevealedToUniText = isRevealedToUni ? 'Revealed to university' : 'Not revealed to university';
  const isRevealedToUniIcon = isRevealedToUni ? regular('eye') : regular('eye-slash');

  return (
    <Box>
      {isAssessed && (
        <Box>
          {showNotes && (
            <>
              <Heading as="h3" fontSize="md" fontWeight="medium" mt="4" mb="2">
                {t('common:assessorsNotes')}
                                            </Heading>
              <Text>{notes}</Text>
            </>
          )}

          <RecordedInterviewDescisionSegment descision={descision} />

          {canEditScoresAndAssessment && (
            <>
              <Heading as="h3" fontSize="md" fontWeight="medium" mb="2">
                {t('common:assessedBy')}
                                            </Heading>
              <Text>{assessedBy}</Text>
            </>
          )}
        </Box>
      )}

      {canEditScoresAndAssessment && (
        <>
          <Text textAlign="center">
            <FontAwesomeIcon className="utility-icon" icon={isRevealedToUniIcon} /> {isRevealedToUniText}
          </Text>
          <ActionButton isAssessed={isAssessed} />
        </>
      )}
    </Box>
  );
}

export default AssessSection;
